var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg023Move(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M494.246,213.453L432.084,151.8c-7.843-7.778-20.506-7.726-28.284,0.116c-7.778,7.843-7.727,20.506,0.116,28.284 l57.269,56.8H276V50.815l56.8,57.269c3.91,3.942,9.054,5.916,14.201,5.916c5.09,0,10.184-1.932,14.083-5.8 c7.843-7.778,7.895-20.441,0.116-28.284l-61.653-62.162C288.191,6.305,273.081,0,257,0s-31.191,6.305-42.547,17.754L152.8,79.916 c-7.778,7.843-7.727,20.506,0.116,28.284c7.844,7.779,20.506,7.727,28.284-0.116L236,52.832V237H50.815l57.269-56.8 c7.843-7.778,7.895-20.441,0.116-28.284c-7.776-7.841-20.441-7.896-28.284-0.116l-62.162,61.653C6.305,224.809,0,239.919,0,256 s6.305,31.191,17.754,42.547L79.916,360.2c3.9,3.868,8.992,5.8,14.083,5.8c5.146,0,10.291-1.974,14.201-5.916 c7.778-7.843,7.727-20.506-0.116-28.284L52.832,277H236v182.168l-54.8-55.252c-7.775-7.84-20.44-7.896-28.284-0.116 c-7.843,7.778-7.895,20.441-0.116,28.284l61.653,62.162C225.809,505.695,240.919,512,257,512s31.191-6.305,42.547-17.754 l61.653-62.162c7.778-7.843,7.727-20.506-0.116-28.284c-7.844-7.778-20.506-7.726-28.284,0.116L276,461.185V277h183.168 l-55.252,54.8c-7.843,7.778-7.895,20.441-0.116,28.284c3.91,3.942,9.054,5.916,14.201,5.916c5.09,0,10.184-1.932,14.083-5.8 l62.162-61.653C505.695,287.191,512,272.081,512,256S505.695,224.809,494.246,213.453z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg023Move);
export default __webpack_public_path__ + "static/media/023-move.99fb925e83e88b683e075fb0dd9d5d74.svg";
export { ForwardRef as ReactComponent };